// csdGateway.js — CSD adapter interface + Kenya mock implementation
// Designed for multi-market extension (add NG, ZA, GH adapters later)

import {
  UPCOMING_AUCTIONS,
  AUCTION_RULES_KENYA,
  TICKETS,
  CSD_ACCOUNTS,
  REPATRIATIONS,
  ROLLOVER_INSTRUCTIONS,
} from '../data/dealingMockData';

// Simulate async network delay
const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
const randomDelay = () => delay(50 + Math.random() * 150);

// ─── Kenya CSD Adapter ────────────────────────────────────────────────
const kenyaAdapter = {
  market: 'KE',
  csdName: 'DhowCSD',

  async getAuctions() {
    await randomDelay();
    return UPCOMING_AUCTIONS.filter((a) => a.market === 'KE');
  },

  async getRules(auctionId) {
    await randomDelay();
    const auction = UPCOMING_AUCTIONS.find((a) => a.id === auctionId);
    return { auction, rules: AUCTION_RULES_KENYA };
  },

  async submitBid(ticket) {
    await randomDelay();
    // Mock: return a CSD reference
    const csdRef = `CBK-BID-${new Date().toISOString().split('T')[0].replace(/-/g, '-')}-${String(Math.floor(Math.random() * 9999)).padStart(4, '0')}`;
    return {
      success: true,
      csdRef,
      submittedAt: new Date().toISOString(),
      ticket: { ...ticket, status: 'submitted_to_csd', csdRef },
    };
  },

  async getAllocation(csdRef) {
    await randomDelay();
    const ticket = TICKETS.find((t) => t.csdRef === csdRef);
    if (!ticket || !ticket.allocation) {
      return { found: false, csdRef };
    }
    return { found: true, csdRef, allocation: ticket.allocation };
  },

  async getPaymentDue(csdRef) {
    await randomDelay();
    const ticket = TICKETS.find((t) => t.csdRef === csdRef);
    if (!ticket || !ticket.payment) {
      return { found: false, csdRef };
    }
    return { found: true, csdRef, payment: ticket.payment };
  },

  async setNettingFlag(accountId, on) {
    await randomDelay();
    const account = CSD_ACCOUNTS.find((a) => a.id === accountId);
    if (!account) return { success: false, error: 'Account not found' };
    return { success: true, accountId, nettingEnabled: on };
  },

  async submitInstruction(instr) {
    await randomDelay();
    return {
      success: true,
      instructionId: `INSTR-${Date.now()}`,
      ...instr,
      submittedAt: new Date().toISOString(),
    };
  },

  async getStatement(accountId, asOf) {
    await randomDelay();
    const account = CSD_ACCOUNTS.find((a) => a.id === accountId);
    if (!account) return { found: false };
    return {
      found: true,
      accountId,
      asOf: asOf || new Date().toISOString().split('T')[0],
      balance: account.balance,
      positions: ROLLOVER_INSTRUCTIONS.filter((r) => r.entityId === account.entityId),
    };
  },

  async getCorporateActions(accountId) {
    await randomDelay();
    // Mock: no pending corporate actions
    return { accountId, actions: [] };
  },
};

// ─── Gateway Registry ──────────────────────────────────────────────────
export const csdGateway = {
  KE: kenyaAdapter,
  // Future: NG: nigeriaAdapter, ZA: southAfricaAdapter, etc.
};

export default csdGateway;
